
import * as modals from "@/lib/modals";
import mixin from "./mixin";
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import NoteFields from "../NoteFields.vue";
import { IOrderResource } from "@/store/types";
import notifications from "../../../lib/notifications";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.customerNotReadyModal,
  components: {
    NoteFields
  }
})
export default class CustomerNotReadyModal extends Mixins(mixin) {
  note: any = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
  followUpDate: Date = null;
  saving: boolean = false;
  customerNotReady: boolean = true;
  currentOrder: IOrderResource = null;

  load() {
    this.show();
    //sf - check this
    this.currentOrder = this.selectedItem;
  }

  get deliveryForId() {
    if(!this.selectedItem)
      return 0;
      
    return this.selectedItem.deliveryForId ?? 0;
  }

  noteUpdated(newNote) {
    this.note = JSON.parse(JSON.stringify(newNote));
  }

  reset() {
    this.note = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
    this.followUpDate = null;
  }

  async save() {
    this.saving = true;

    try {
      await orderModule.updateCustomerNotReady({
        customerNotReady: this.customerNotReady,
        followUpDate: this.followUpDate,
        orderNote: this.note,
        headerNumber: this.currentOrder.headerNumber
      });
      notifications.success("Customer Not Ready", "Customer Not Ready successfully updated.");
      await this.refreshOrders();
      this.hideModal();
    } catch (ex) {
      notifications.error("Customer Not Ready", "Failed to update customer not ready", ex);
    }

    this.saving = false;
  }
}
